import { useState } from "react";
import { Button, TextField, Box, InputAdornment, IconButton } from "@mui/material";
import { Search, Clear } from "@mui/icons-material";

const WSU_RED = "#A60F2D";

const fieldSx = {
  flex: 1,
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px 0 0 8px",
    "&:hover fieldset": { borderColor: WSU_RED },
    "&.Mui-focused fieldset": { borderColor: WSU_RED },
  },
  "& .MuiInputLabel-root.Mui-focused": { color: WSU_RED },
};

export const SearchBar = ({ text, onTextChange, placeholderValues, handleClick }) => {
  const [inputValue, setInputValue] = useState(text || "");

  const executeSearch = () => {
    if (inputValue.trim() !== "") {
      onTextChange(inputValue);
      handleClick();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") executeSearch();
  };

  const handleClear = () => {
    setInputValue("");
  };

  return (
      <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
        <TextField
            fullWidth
            size="medium"
            label="Search by Account Name / WSU ID"
            placeholder={placeholderValues}
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyDown={handleKeyDown}
            sx={fieldSx}
            InputProps={{
              startAdornment: (
                  <InputAdornment position="start">
                    <Search sx={{ color: inputValue ? WSU_RED : "#aaa", transition: "color 0.2s" }} />
                  </InputAdornment>
              ),
              endAdornment: inputValue ? (
                  <InputAdornment position="end">
                    <IconButton size="small" onClick={handleClear} edge="end">
                      <Clear fontSize="small" />
                    </IconButton>
                  </InputAdornment>
              ) : null,
            }}
        />
        <Button
            variant="contained"
            onClick={executeSearch}
            disabled={!inputValue.trim()}
            sx={{
              height: 56,
              px: 4,
              borderRadius: "0 8px 8px 0",
              backgroundColor: WSU_RED,
              color: "white",
              fontWeight: 600,
              letterSpacing: 0.5,
              boxShadow: "none",
              whiteSpace: "nowrap",
              "&:hover": { backgroundColor: "#8a0c25", boxShadow: "none" },
              "&.Mui-disabled": { backgroundColor: "#ddd", color: "#aaa" },
            }}
        >
          Search
        </Button>
      </Box>
  );
};